let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("1n2WK"), load("kya3j")]).then(() => parcelRequire('kCU4G'));